import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { IInputsForSC } from '../../inputs.models';

const noAnimation = css`
  & > svg {
    animation: none !important;
  }
`;

const fadeAnimation = css`
  &.icon-error-enter > svg {
    animation:   from {
      opacity: 0;
    }
    to {
      opacity: 1;
    } 0.3s forwards;
  }

  &.icon-error-exit > svg {
    animation: from {
      opacity: 1;
    }
    to {
      opacity: 0;
    } 0.3s forwards;
  }
`;

const spinAnimation = css`
  &.icon-loading-enter > svg {
    animation: to {
      transform: rotate(360deg);
    } 2s linear infinite;
  }
`;

const dashAnimation = css`
  &.icon-loading-enter > svg > circle {
    animation: 0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    } 1.5s ease-in-out infinite;
  }
`;

const variants = {
  svgContainer: {
    animated: css`
      border-radius: 0 4px 4px 0;
      padding: 18px 16px;
    `,
    'mva:animated': css`
      border-radius: 0 6px 6px 0;
      padding: 10px 16px;
    `,
    'mva:static': css`
      border-radius: 0 6px 6px 0;
      padding: 10px 16px;
    `,
  },
};

const svgContainer = (props: IInputsForSC) => css`
  position: absolute;
  right: 0;
  top: 0;

  & path {
    transition: all 0.3s ease;
  }

  ${props.variant ? variants.svgContainer[props.variant] : ''}
`;

export const Icon = styled.span<IInputsForSC>`
  ${svgContainer}
  pointer-events: none;
`;

export const IconLoading = styled.span<IInputsForSC>`
  ${svgContainer}
  ${spinAnimation}
  ${dashAnimation}
  pointer-events: none;
`;

export const IconButton = styled.button<IInputsForSC & { isClearable?: boolean }>`
  ${svgContainer}
  ${({ isClearable }) => (!isClearable ? '' : noAnimation)};
  background-color: transparent;
  border: none;
  box-sizing: content-box;
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  margin: 0;
  outline: none;
`;

export const IconError = styled.span<IInputsForSC>`
  ${svgContainer}
  ${fadeAnimation}
  pointer-events: none;
`;

